import React, {Component} from 'react';
import {Grid, Popup, Icon} from 'semantic-ui-react';
import moment from 'moment';
import {dateFormatShow} from '../../../../../common/constants/datesFormat';
import StockTdeModal from '../modals/stockTDE';
import StockModal from '../modals/stock';

class PartInfo extends Component {
  constructor(props) {
    super(props);
    this.onGoToSustituteClick = this.onGoToSustituteClick.bind(this);
  }

  onGoToSustituteClick(code) {
    this.props.push(`/partes/analisis/editar/${code}`);
  }

  renderNumericValue(width, value = 0) {
    return <Grid.Column width={width}>{value}</Grid.Column>;
  }

  renderLabel(width, label, paddingLeft) {
    const classes = paddingLeft ? 'padding-left' : '';
    return (
      <Grid.Column width={width} className={classes}>
        <span className='bolder'>{label}</span>
      </Grid.Column>
    );
  }

  renderAlert() {
    const {data} = this.props;
    const stockTDE = data.stockToyotaEcuador;
    const stockUpperLimit = data.salesMip;
    const stockLowerLimit = data.stockLowerLimit;

    if (!stockUpperLimit) {
      return null;
    }
    if (stockTDE <= stockLowerLimit || stockTDE >= stockUpperLimit) {
      return <Icon link className='close circle' color='red' size='large' />;
    }
    return <Icon link className='check circle' color='green' size='large' />;
  }

  renderTooltipAlert() {
    const {data} = this.props;
    const stockTDE = data.stockToyotaEcuador;
    const stockUpperLimit = data.salesMip;
    const stockLowerLimit = data.stockLowerLimit;

    if (!stockUpperLimit) {
      return null;
    }
    const isIntoRange =
      stockTDE >= stockLowerLimit && stockTDE <= stockUpperLimit;
    const message = `El Stock TDE (${stockTDE}) ${
      isIntoRange ? '' : 'no'
    } se encuentra en el rango
    entre MAD x LT (${stockLowerLimit}) y MIP venta (${stockUpperLimit}).`;
    return <p>{message}</p>;
  }

  renderSustituteLink() {
    const {data} = this.props;
    if (data.replacement && data.replacement.code) {
      return (
        <div
          className='link'
          onClick={() => this.onGoToSustituteClick(data.replacement.code)}
        >
          {`${data.replacement.code} (${data.replacement.franchise})`}
        </div>
      );
    }
    return null;
  }

  render() {
    const {data, code} = this.props;
    const lastPurchaseFormated = data.lastPurchase ?
      moment(data.lastPurchase).format(dateFormatShow) :
      '';

    return (
      <Grid.Row columns={2} divided className='border-bottom row-content'>
        <Grid.Column>
          <Grid>
            <Grid.Row>
              {this.renderLabel(3, 'Sustituto')}
              <Grid.Column width={5}>{this.renderSustituteLink()}</Grid.Column>
              {this.renderLabel(2, 'ICC')}
              {this.renderNumericValue(6, data.icc)}
            </Grid.Row>
            <Grid.Row>
              {this.renderLabel(3, 'Product-code')}
              {this.renderNumericValue(5, data.productCode)}
              {this.renderLabel(2, 'SCC')}
              {this.renderNumericValue(6, data.scc)}
            </Grid.Row>
          </Grid>
        </Grid.Column>
        <Grid.Column>
          <Grid columns='equal'>
            <Grid.Row>
              {this.renderLabel(4, 'Stock TDE', true)}
              <Grid.Column width={4}>
                <StockTdeModal
                  code={code}
                  quantity={data.stockToyotaEcuador || 0}
                  quantityAvailable={data.availableStockToyotaEcuador || 0}
                />
                <Popup
                  trigger={
                    <span className='margin-left'>{this.renderAlert()}</span>
                  }
                  content={this.renderTooltipAlert()}
                  position='top center'
                  inverted
                />
              </Grid.Column>
              {this.renderLabel(4, 'Stock Sustituto')}
              <Grid.Column width={4}>
                <StockModal
                  code={data && data.replacement ? data.replacement.code : ''}
                  quantity={
                    data.replacement && data.replacement.stock ?
                      data.replacement.stock :
                      ''
                  }
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              {this.renderLabel(4, 'Stock Nacional', true)}
              <Grid.Column width={4}>
                <StockModal code={code} quantity={data.nationalStock || 0} />
              </Grid.Column>
              {this.renderLabel(4, 'Última compra')}
              {this.renderNumericValue(4, lastPurchaseFormated)}
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default PartInfo;
